import { Colors, Platforms, Services, delimiters } from '@sigma-frontend-libs/commons'
import { FileEncodings } from '@sigmasms/shared-types'

import { icons, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Encoding',

  mixins: [ proxy() ],

  computed: {
    preset: {
      get() {
        switch (this.proxy.encoding) {
          case FileEncodings.win1251:
          case FileEncodings.win1252: return Platforms.windows
          case FileEncodings.maccyrillic: return Platforms.macintosh
          default: return 'user'
        }
      },
      set(platform) {
        let encoding
        switch (platform) {
          case Platforms.windows: {
            encoding = FileEncodings.win1251
            break
          }
          case Platforms.macintosh: {
            encoding = FileEncodings.maccyrillic
            break
          }

          default: {
            encoding = FileEncodings.utf8
            break
          }
        }

        this.proxy.encoding = encoding
        this.proxy.delimiter = delimiters.semicolon
      }
    },

    presetButtons() {
      return [ Platforms.windows, Platforms.macintosh ].map(platform => {
        return {
          value: platform,
          label: this.getTranslate(`platforms.${platform}`)
        }
      })
    },

    encodingSettings() {
      return {
        encoding: {
          items: Object.values(FileEncodings).map(encoding => {
            return {
              title: this.getTranslate(`${Services['report-manager']}.encodings.${encoding}`),
              value: FileEncodings[encoding]
            }
          })
        },
        delimiter: {
          items: Object.keys(delimiters).map(delimiter => {
            return {
              title: this.getTranslate(`${Services['report-manager']}.delimiters.${delimiter}`),
              value: delimiters[delimiter]
            }
          })
        }
      }
    },

    title() {
      let preset
      if (Object.values(Platforms).includes(this.preset)) {
        preset = this.getTranslate(`platforms.${this.preset}`)
      } else {
        preset = this.getTranslate(`${Services['report-manager']}.labels.encodingSettings.presets.${this.preset}`)
      }

      return [ this.getTranslate(`${Services['report-manager']}.labels.encodingSettings.preset`), preset ].join(': ')
    },

    label() {
      const result = []
      for (const setting in this.encodingSettings) {
        const currentItem = this.encodingSettings[setting].items.find(item => {
          return item.value === this.proxy[setting]
        })
        if (currentItem) {
          result.push(
            [
              this.getTranslate(`${Services['report-manager']}.labels.encodingSettings.${setting}`),
              currentItem.title
            ].join(': ')
          )
        }
      }

      return result.join(' | ')
    },

    activatorProps() {
      return {
        value: this.title,
        label: this.label,
        icon: icons.code,
        color: Colors.grey,
        onClick: () => {
          return null
        },
        width: '100%'
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.preset = this.platform
    })
  },

  render
}
